import React from 'react'
import { Autocomplete, InputAdornment, TextField } from '@mui/material'

import { ReactComponent as BookLightIcon } from '@/assets/icons/book-light.svg'
import { ChevronDownIcon } from '@/assets/icons/chevron-icons'

const subjectOptions = [
  { name: 'English As New Language', value: 'esl' },
  { name: 'World Languages', value: 'world_languages' },
  { name: 'Social Studies', value: 'social_studies' },
  { name: 'English Language Arts', value: 'ela' },
  { name: 'Science', value: 'science' },
]

function SubjectSelector({
  subjects = [],
  setSubjects = () => {},
  multiple = false,
  showStartAdornment = false,
  borderRadius,
}) {
  // Map the value strings to the corresponding option objects
  const selectedOptions = multiple
    ? subjects.map(subjectValue => subjectOptions.find(option => option.value === subjectValue)).filter(Boolean)
    : subjectOptions.find(option => option.value === subjects[0]) || null

  const handleChange = (event, newValue) => {
    if (multiple) {
      // For multiple selection, map the selected options to their values
      setSubjects(newValue ? newValue.map(option => option.value) : [])
    } else {
      // For single selection, set the value of the selected option
      setSubjects(newValue ? [newValue.value] : [])
    }
  }

  return (
    <Autocomplete
      filterSelectedOptions={multiple}
      getOptionLabel={option => option.name}
      id="subject-selector"
      isOptionEqualToValue={(option, value) => option.value === value.value}
      multiple={multiple}
      options={subjectOptions}
      popupIcon={<ChevronDownIcon style={{ color: '#667085' }} width={20} />}
      renderInput={params => (
        <TextField
          InputProps={{
            ...params.InputProps,
            startAdornment: showStartAdornment && (
              <>
                <InputAdornment position="start">
                  <BookLightIcon />
                </InputAdornment>
                {params.InputProps.startAdornment}
              </>
            ),
          }}
          placeholder={multiple ? 'Select subjects' : 'Select a subject'}
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              borderRadius: '8px !important',
            },
            '& .MuiOutlinedInput-root': {
              minHeight: 44,
            },
          }}
          {...params}
        />
      )}
      sx={{
        width: '100%',
        '& .MuiAutocomplete-inputRoot': {
          minHeight: 44,
          padding: '0px 5px',
        },
      }}
      value={selectedOptions}
      onChange={handleChange}
    />
  )
}

export default SubjectSelector
